import React from 'react'

import NameInput from './NameInput.js'
import ChoisirSalon from './ChoisirSalon.js'

function App(props) {
  const [name, _setName] = React.useState(null);

  function setName(name) {
    if(!name)
      localStorage.removeItem("name", name);
    else
      localStorage.setItem("name", name);
    _setName(name);
  }

  React.useEffect(() => {
    let name = localStorage.getItem("name");
    if(name)
      _setName(name);
  }, []);

  return <div className="container pb-4">
    {name ?
      <ChoisirSalon name={name} onBack={() => setName(null)}/>
      :
      <NameInput onValid={name => {
        setName(name);
      }}/>
    }
  </div>
}

export default App